import { render, staticRenderFns } from "./Weblogs.vue?vue&type=template&id=356ab9e4"
import script from "./Weblogs.vue?vue&type=script&lang=js"
export * from "./Weblogs.vue?vue&type=script&lang=js"
import style0 from "./Weblogs.vue?vue&type=style&index=0&id=356ab9e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports